import Layout from "../../../components/Layout";
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import BreadCrumb from "../../../components/BreadCrumb";
import DetailsText from "../components/DetailsText";
// import useStyles from "../styles";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Grid } from "@mui/material";
import Badge from "../../../components/Badge";
import SubjectsInClass from "./SubjectsInClass";
import StudentInClass from "./StudentsInClass";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import ClassResults from "./ClassResults";
import Button from "../../../components/Button";
import Modal from "../../../components/Modal";
import BulkStudentImport from "../../../components/BulkStudentImport";

const CLASS_ENDPOINT = "/api/v1/class";
const CLASS_RESULT_NOTIFICATION_ENDPOINT = "/api/v1/school-exams/result/notify/";
const BATCH_STUDENTS = "/api/v1/student-invite/batch";

const ClassDetails = () => {
  // const classes = useStyles();

  const { id } = useParams();
  const [value, setValue] = useState("1");
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [notifying, setIsNotifying] = useState(false);
  const [noticationModal, setNotificationModal] = useState(false);
  const [bulkModal, setBulkModal] = useState(false);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleNotificationModal = () => {
    setNotificationModal(!noticationModal);
  };

  const handleCreateBulkModal = () => {
    setBulkModal(!bulkModal);
  };

  // Send Notification
  const handleSendNotification = () => {
    setIsNotifying(true);
    httprequest.post(`${CLASS_RESULT_NOTIFICATION_ENDPOINT}${id}`).then((res) => {
      setIsNotifying(false);
      handleNotificationModal();
      toast.success(res?.data?.message);
    }).catch((err) => {
      setIsNotifying(false);
      toast.error(err.response?.data?.message);
    });
  };

  const handleCreateBatchStudent = async (file) => {
    setIsLoading(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("class_id", id);

    try {
      const res = await httprequest.post(BATCH_STUDENTS, formData);
      toast.success(res?.data?.message);
      setBulkModal(false);
      location.reload();
    } catch (err) {
      toast.error(err?.response?.data?.message);
      location.reload();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    httprequest.get(`${CLASS_ENDPOINT}/${id}`).then((res) => {
      setData(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  }, []);

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb link_one="/class-activities/classes" link_one_name="Classes" active="Class Details" description={`See the details of ${data?.class_name}`} />
            </div>
            <div className="flex gap-10">
              <Button
                variant="primaryoutline"
                buttonSize="fluid"
                color="btnfontprimary"
                onClick={handleCreateBulkModal}
                buttonName="Import Batch Students"
              />
              {/* <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                buttonName="Send Notification"
                onClick={handleNotificationModal}
              /> */}
            </div>
          </div>
          <div className="page-content">
            <TabContext value={value}>
              <div className="tablist-container padding-left-16">
                <Tabs className="overide-tablist" onChange={handleChange} aria-label="lab API tabs example">
                  <Tab label="Class Details" value="1" />
                  <Tab label="Students in Class" value="2" />
                  <Tab label="Subjects" value="3" />
                  <Tab label="Class Result" value="4" />
                </Tabs>
              </div>
              <TabPanel value="1" className="tabpanel-overide">
                <Grid container spacing={4}>
                  <Grid item lg={3} md={4} sm={6} xs={12}>
                    <DetailsText title="Name" subtitle={data?.class_name} />
                  </Grid>
                  <Grid item lg={3} md={4} sm={6} xs={12}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <DetailsText title="Class Type" subtitle={<Badge status={data?.class_type} />} />
                    </Grid>
                  </Grid>
                  <Grid item lg={3} md={4} sm={6} xs={12}>
                    <DetailsText title="Class Teacher" subtitle={
                      <div className="link-teacher">
                        <Link to={`/users/employees/${data?.class_teacher?.id}`}> {`${data?.class_teacher?.first_name} ${data?.class_teacher?.last_name}`}</Link>
                      </div>}
                    />
                  </Grid>
                  <Grid item lg={3} md={4} sm={6} xs={12}>
                    <DetailsText title="Created At" subtitle={data?.created_at?.substring(0, 10)} />
                  </Grid>
                  <Grid item lg={3} md={4} sm={6} xs={12}>
                    <DetailsText title="Updated At" subtitle={data?.updated_at?.substring(0, 10)} />
                  </Grid>
                  {data?.class_type === "virtual" ? (
                    <>
                      {data?.meeting_link && (
                        <Grid item lg={3} md={4} sm={6} xs={12}>
                          <DetailsText title="Meeting Link" subtitle={data?.meeting_link || "No Meeting Link"} />
                        </Grid>
                      )}
                      {data?.start_time && (
                        <Grid item lg={3} md={4} sm={6} xs={12}>
                          <DetailsText title="Start Time" subtitle={data?.start_time || "--------"} />
                        </Grid>
                      )}
                      {data?.end_time && (
                        <Grid item lg={3} md={4} sm={6} xs={12}>
                          <DetailsText title="End Time" subtitle={data?.end_time || "--------"} />
                        </Grid>
                      )}
                      {data?.virtual_class_date && (
                        <Grid item lg={3} md={4} sm={6} xs={12}>
                          <DetailsText title="Virtual Class Date" subtitle={data?.virtual_class_date || "--------"} />
                        </Grid>
                      )}
                      {data?.attendees && (
                        <Grid item lg={3} md={4} sm={6} xs={12}>
                          <DetailsText title="Attendees" subtitle={data?.attendees?.map((attendee) => {
                            return <li key={attendee}>{attendee}</li>;
                          })}
                          />
                        </Grid>
                      )}
                    </>
                  ) : null}
                </Grid>
              </TabPanel>
              <TabPanel sx={{ padding: "0px" }} value="2">
                <StudentInClass />
              </TabPanel>
              <TabPanel sx={{ padding: "0px" }} value="3">
                <SubjectsInClass />
              </TabPanel>
              <TabPanel value="4">
                <ClassResults />
              </TabPanel>
            </TabContext>
            {/* <ToastContainer /> */}
          </div>
          <Modal
            title="Send Result Notification"
            subtitle=""
            modalContent={
              <>
                <div>
                  <div>
                    <p>You are about to send result notification to Guardians</p>
                  </div>
                </div>
              </>
            }
            modalFooter={
              <>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  isLoading={notifying}
                  buttonName="Send Notification"
                  onClick={handleSendNotification}
                />
              </>
            }
            isopen={noticationModal}
            closeModal={handleNotificationModal}
          />
          {/* CREATE BULK EMPLOYEE */}
          <Modal
            title="Create Batch Students"
            subtitle={
              <div>Create multiple students at the same time by importing a csv file.
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={10} md={12} sm={12} xs={12}>
                    <p className="key-pair-name">1. Download sample .csv file here.</p>
                    <p className="key-pair-name">2. Fill in all columns. All fields are mandatory.</p>
                    {/* <p className="key-pair-name">3. Allowed staff types are academic teaching staffs.</p> */}
                    <p className="key-pair-name">3. Do not include extra columns nor rename columns in the document.</p>
                    <p className="key-pair-name">4. Upload the completed excel document</p>
                  </Grid>
                  <BulkStudentImport
                    createClick={(file) => handleCreateBatchStudent(file)}
                    isLoading={isLoading}
                  />
                </Grid>
              </>
            }
            modalFooter={
              <>
              </>
            }
            isopen={bulkModal}
            closeModal={handleCreateBulkModal}
          />
        </>
      }
    />
  );
};

export default ClassDetails;
